<template>
    <!-- 总容器 -->
    <div class="main-content">
        <!-- 左边容器 -->
        <div :class="leftContent">
            <div class="left-content">
                  <template v-if="userInfo.switchLayoutFlg=='1'">
                    <ApplicationMenu
                          ref="applicationMenuRef"
                          v-show="isShowMenu && treeState === 1"
                          :defaultAppIndex="defaultAppIndex"
                          :isNewMenu="isNewMenu"
                          :appSystemlList="appSystemlList"
                          :fullScreen="fullScreen"
                          @setMenuWidth="setMenuWidth"
                          @nodeClick="handleModelSelected"
                      />
                  </template>
                  <template v-if="userInfo.switchLayoutFlg=='2'">
                      <el-tree class="filter-tree"
                        v-show="isShowMenu && treeState === 1"
                        :data="treeData"
                        :highlight-current="true"
                        :expand-on-click-node="false"
                        :default-expanded-keys="idExpandedArr"
                        node-key="id"
                        @node-click="getNode"
                        ref="tree"
                      >
                      <span class="custom-tree-node" slot-scope="{ node, data }">
                          <span>
                              <i :class="data.icon"></i>{{ data.label }}
                          </span>
                      </span>
                    </el-tree>
                  </template>
                  <SearchConditionSide
                      ref="searchConditon"
                      v-show="treeState === 0"
                      :conditionFields="conditionFields"
                      :fullScreen="fullScreen"
                      @searchForList="searchForList"
                      @resetSearchConditon="resetSearchConditon"
                  />
            </div>
        </div>
        <!-- 右边容器 -->
        <div :class="rightContent">
            <div  v-if="isShowModelFormList" class="form-data-box">
                <div class="content-tree" v-if="isCollapseForInit">
                    <el-tree
                        highlight-current
                        node-key="key"
                        @node-click="handleTreeNode"
                        :current-node-key="selectNodeId"
                        :default-expanded-keys="idSearchExpandedArr"
                        :expand-on-click-node="false"
                        :data="searchTreeData"
                    >
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                        <span v-if="data.children && data.children.length>0">
                            <i class="icon-other-zuzhiqunzu iconfont" style="color:#1296db;font-size:16px;"></i>&nbsp;{{ data.label }}
                        </span>
                        <span v-else>
                           &nbsp;{{ data.label }}
                        </span>
                    </span>
                    </el-tree>
                    <div v-if="searchFieldList.length>0" class="left-icon">
                        <el-dropdown trigger="click"  @command="handleCommand">
                            <span class="el-dropdown-link">
                                <i class="el-icon-connection" style="color:#1296db;font-size:16px;cursor:pointer;" title="切换字段"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item v-for="(item,index) in searchFieldList"  :key="index" :command="item.id">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
                <ModelFormList
                    v-if="isShowModelFormList"
                    ref="formListChild"
                    :key="loadTimer"
                    :isReturnToNav="isReturnToNav"
                    :isNewPage="isNewMenu"
                    :isCollapseForInit="isCollapseForInit"
                    :selectedModel="selectedModel"
                    :formBtnAuth="formBtnAuth"
                    :minuend="minuend"
                    @switchMode="handleSwitchFormMode"
                    :fullScreen="fullScreen"
                    @handleFullScreen="handleFullScreen"
                    @setShowleftList="setShowleftList"
                    @collapseLeftSide="collapseLeftSide"
                    @refreshSearchConditon="refreshSearchConditon"
                    @handleNavPage="handleNavPage"
                />
            </div>
            <!-- BI -->
           <div v-if="isShowBi" class="bi-form">
                <DashBoard
                    :key="loadTimer"
                    ref="dashBoardRef"
                    :chartType="chartType"
                    :chartData="chartData"
                    :selectedModel="selectedModel"
                    :chartSettings="chartSettings"
                    v-if="isShowBi"
                    :isCollapseForInit="isCollapseForInit"
                    :showSearch="true"
                    :showLeftSwitch="true"
                    :isShowModelFormList="isShowModelForm"
                    @getBiData="getBiData"
                    @setShowleftList="setShowleftList"
                    @collapseLeftSide="collapseLeftSide"
                    @refreshSearchConditon="refreshSearchConditon"
                />
            </div>
            <!-- 审批流 -->
            <div v-if="isShowdApproveModel" class="approve-model-content">
                <MyApproval
                    :key="loadTimer"
                    ref="myApproval"
                    v-if="isShowdApproveModel"
                    :approveModel="approveModel"
                    :showLeftSwitch="true"
                    :showTit="true"
                    @setShowleftList="setShowleftList"
                    @collapseLeftSide="collapseLeftSide"
                />
            </div>
            <!-- 仪表盘 -->
            <div class="warehousing-model-content" v-if="isShowWarehousing">
                <DataWarehousingPreview
                    v-if="isShowWarehousing"
                    :warehousing="warehousingPreviewData"
                    :warehousingPreviewTitle="''"
                    >

                </DataWarehousingPreview>
            </div>
        </div>
        <el-dialog class="popAddModelDetail" width="95%" top="1vh" :fullscreen="true" append-to-body :visible.sync="isShowModelDetail" @close="hideDialog" v-if="isShowModelDetail">
            <ModelDetail
                :key="loadTimerModelDetail"
                ref="modelDetailChild"
                v-if="isShowModelDetail"
                :isShowForm="isShowForm"
                :formInfo="formInfo"
                :isReturnToNav="isReturnToNav"
                :before-close="handleClose"
                @setIsShowForm="setIsShowForm"
                @modelComplete="handleModelComplete"
                @switchMode="handleSwitchFormMode"
                @handleNavPage="handleNavPage"
                @clearTimeOut="clearTimeOut"
                @closeModelDetail="hideDialog"
            />
        </el-dialog>
        <template v-if="ifFullScreen">
            <BusinessConsole ref="businessConsole" :menuFormIndex="nowMenuFormIndex" />
        </template>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import jsCookies from 'js-cookie';
import ApplicationList from './ApplicationList';
import BusinessConsole from './BusinessConsole';
import ModelList from './ModelList';
import ModelDetail from './ModelDetail';
import ModelFormList from './ModelFormList';
import { isEmpty } from 'lodash';
import * as constants from '@/common/constants';
import DashBoard from '@/components/DashBoard';
import MyApproval from '@/pages/process/MyApproval/MyApproval';
import SearchConditionSide from '@/components/SearchCondition/SearchConditionSide';
import DataWarehousingPreview from '@/components/DataWarehousing/DataWarehousingPreview';
import { objectKeyIsEmpty } from '@/utils/grocer';
import {
    getApplicationModelDetail,
    getApplicationModelMenuList,
    getPublishedModelbyAppIdList,
    getModelFormById,
    saveAppModelForm,
    getFormDashBoardData,
    getApproveData,
    getFormFieldListByIds,
    getCurrentUserInfo,
    loginOut,
    getWarehousing,
    checkDataLegitimacy,
    getApplicationModelTreeMenu,
    getPartyBUildingAuthorize,
    getFormLeftTree
} from '@/data-model';
export default {
    components: {
        ApplicationList,
        ModelList,
        ModelDetail,
        ModelFormList,
        BusinessConsole,
        DashBoard,
        MyApproval,
        SearchConditionSide,
        DataWarehousingPreview
    },
    data () {
        return {
            loadTimerModelDetail: '',
            leftContent: 'main-content-left-show',
            rightContent: 'right-content-show',
            treeState: 1,
            loadTimer: new Date().getTime(),
            isCollapseForInit: true,
            appSystemlList: [],
            ifFullScreen: false,
            isShowForm: false,
            menuWidth: '230px',
            isShowMenu: false,
            defaultAppIndex: '',
            nowMenuFormIndex: '',
            isShowAppList: false,
            isShowModelList: false,
            isShowModelDetail: false,
            isShowModelFormList: false,
            isShowWarehousing: false,
            applicationList: [],
            modelList: [],
            formInfo: {},
            modelId: '',
            sourceFieldsList: [],
            warehousingPreviewData: [],
            selectedApp: {},
            selectedModel: {},
            idExpandedArr: [],
            idSearchExpandedArr: [],
            active: false, // 是否显示侧滑弹窗
            formBtnAuth: {
                // 表单按钮权限
                type: Object,
                default: function () {
                    return {
                        isShowView: true, // 查看
                        isShowAdd: true, // 新增
                        isShowEdit: true, // 修改
                        isShowDelete: true, // 删除
                        isShowImport: true, // 导入
                        isShowExport: true, // 导出
                        isShowSyn: true, // 同步流程数据
                        isShowConfig: true // 进入应用配置
                    };
                }
            },
            chartType: 1,
            chartSettings: {},
            chartData: {},
            isShowBi: false,
            isShowdApproveModel: false,
            BiSearchCondition: {
                formId: '',
                searchCondition: []
            },
            isShowModelForm: 0,
            approveModel: {
                approveModelIds: '',
                approveFromIds: ''
            },
            conditionFields: [],
            treeData: [],
            searchTreeData: [],
            selectNodeId: 0,
            searchConditionExt: [],
            searchFieldList: [],
            searchCacheList: []
        };
    },
    computed: {
        ...mapGetters([
            'userInfo'
        ])
    },
    async created () {
        this.ifFullScreen = false;
        await this._getCurrentUserInfo();
    },
    props: {
        fullScreen: {
            type: Boolean,
            default: false
        },
        isReturnToNav: {// 为发起审批成功后，判断来自于新交互模式还是旧模式，默认旧模式
            type: Boolean,
            default: false
        },
        menuFormIndex: {
            // 左边菜单定位显示的表单
            type: String
        },
        appId: {
            type: Number,
            default: 0
        },
        isNewMenu: {// 是否新菜单引用
            type: Boolean,
            default: false
        },
        minuend: {
            type: Number,
            default: 80
        },
        selectModelId: {
            type: String
        },
        oldAppId: {
            type: String
        }
    },
    watch: {
        appId (newVal, oldVal) {
            this._initPage();
        }
    },
    methods: {
        ...mapActions([
            constants.VUEX_ACTIONS_ROUTER_GET_ALL,
            constants.VUEX_ACTIONS_SIDEBAR_TOGGLE,
            constants.VUEX_ACTIONS_USER_INFO,
            constants.VUEX_ACTIONS_REMIND_NUM,
            constants.VUEX_ACTIONS_NAV_SHOW_LEFT,
            constants.VUEX_ACTIONS_NAV_NUM_DATA,
            constants.VUEX_ACTIONS_TAGS_VIEW_ADD,
            constants.VUEX_ACTIONS_TAGS_VIEW_DELETE,
            constants.VUEX_ACTIONS_WORK_PLANT_ENTRY,
            constants.VUEX_ACTIONS_LAYOUT_TYPE,
            constants.VUEX_ACTIONS_NAV_SHOW_LEFT
        ]),
        async _getCurrentUserInfo () {
            let userInfo = {};
            if (isEmpty(this.userInfo)) {
                userInfo = await getCurrentUserInfo();
                this[constants.VUEX_ACTIONS_USER_INFO](userInfo);
            } else {
                userInfo = this.userInfo;
            }
            if (!userInfo) {
                await loginOut();
                window.sessionStorage.removeItem('currentUserType');
                window.sessionStorage.removeItem('currentUserInfo');
                window.sessionStorage.removeItem('isNewPageInitLoad');
                jsCookies.remove('JSESSIONID');
                this.navLogin();
            }
            this[constants.VUEX_ACTIONS_ROUTER_GET_ALL]();
            setTimeout(() => {
                if (this.$refs.navbar) {
                    this.$refs.navbar.setUserPic(userInfo.userPic);
                }
            }, 0);
            let str = JSON.stringify(userInfo);
            window.sessionStorage.setItem('currentUserInfo', str);
            window.localStorage.setItem('currentUserInfo', str);
            this._initPage();
        },
        getMenuStyle (width) {
            return {
                width: width
            };
        },
        setMenuWidth (width) {
            this.menuWidth = width;
        },
        async _initPage () {
            this.loadTimer = new Date().getTime();
            this.isShowMenu = false;
            let defaultAppIndex = '';
            let locationAppId = this.$route.params.appId;
            let locationModelId = this.$route.params.modelId;
            if (this.appId === 0) {
                this.appSystemlList = await getApplicationModelMenuList();
            } else {
                locationAppId = this.appId;
                let param = { appId: this.appId };
                if (this.userInfo.switchLayoutFlg == 1) {
                    if (this.isNewMenu) {
                        param.isNewMenu = 1;
                    }
                    this.appSystemlList = await getApplicationModelMenuList(param);
                    if (this.appSystemlList.length === 0) {
                        this.$message({
                            duration: 1000,
                            message: '当前应用下没有授权的表单',
                            type: 'error'
                        });
                    }
                } else {
                    param.requireType = '1';
                    param.modelType = '2';
                    // console.log(param);
                    let modelTree = await getApplicationModelTreeMenu(param);
                    this.treeData = modelTree;
                    if (this.selectModelId) {
                        this.idExpandedArr.push(this.selectModelId);
                    } else {
                        if (this.treeData && this.treeData.length > 0) {
                            this.idExpandedArr = [];
                            this.idExpandedArr.push(this.treeData[0].id);
                        }
                    }
                    // 默认点击
                    if (this.menuFormIndex) {
                        this.setMenuForm(this.treeData);
                    } else {
                        this.setFirstMenuForm(this.treeData);
                    }
                }
            }
            // 新页面菜单过滤（报表和BI）
            if (!isEmpty(this.menuFormIndex)) {
                this.defaultAppIndex = this.menuFormIndex;
                // 打开模型详情
                let modelInfo = { id: '' };
                modelInfo.id = this.defaultAppIndex;
                this.handleModelSelected(modelInfo);
            } else if (typeof locationModelId === 'undefined' || locationModelId === 'undefined' || locationModelId === ':modelId') {
                this.appSystemlList.find(item => {
                    if (Number(item.id) === Number(locationAppId)) {
                        if (item.subModel && item.subModel.length > 0) {
                            // 要是应用下有模型则默认显示第一个
                            defaultAppIndex = item.subModel[0].id;
                        } else if (item.children[0].children) {
                            // 其次在功能下有模型则默认显示第一个
                            defaultAppIndex = item.children[0].children[0].id;
                        }
                        // TODO
                        let modelInfo = { id: '' };
                        modelInfo.id = defaultAppIndex;
                        this.handleModelSelected(modelInfo);
                    }
                });
                this.defaultAppIndex = defaultAppIndex;
            } else {
                this.defaultAppIndex = locationModelId;
            }
            this.isShowMenu = true;
        },
        setMenuForm (data) {
            if (data && data.length > 0) {
                for (let i = 0; i < data.length; i++) {
                    let cur = data[i];
                    if (cur.isLeaf == 0 && cur.id == this.menuFormIndex) {
                        this.getNode(cur);
                        this.$nextTick().then(() => {
                            this.$refs.tree.setCurrentKey(cur.id);
                        });
                    } else {
                        this.setMenuForm(cur.children);
                    }
                }
            }
        },
        setFirstMenuForm (data) {
            if (data && data.length > 0) {
                let cur = data[0];
                if (cur.isLeaf == 0) {
                    this.getNode(cur);
                    this.$nextTick().then(() => {
                        this.$refs.tree.setCurrentKey(cur.id);
                        this.idExpandedArr = [];
                        this.idExpandedArr.push(cur.id);
                        this.getNode(cur);
                    });
                } else {
                    this.setFirstMenuForm(cur.children);
                }
            }
        },
        filterPageMenu (oldMenus) {
            if (this.isNewMenu) {
                let appSystemlList = [];
                let reportList = [];
                appSystemlList = oldMenus;
                for (let i = 0; i < appSystemlList.length; i++) {
                    let curObj = appSystemlList[i];
                    let subModel = curObj.subModel;
                    let children = curObj.children;
                    if (subModel && subModel.length > 0) { // 如果存在直属子节点则取出来
                        for (let i = 0; i < subModel.length; i++) {
                            let subModelObj = subModel[i];
                            if (subModelObj.modelType < 2) { // 这是报表
                                reportList.push(subModelObj);
                            }
                        }
                    }
                    if (children && children.length > 0) { // 如果子集则继续便利
                        for (let i = 0; i < children.length; i++) {
                            let childrenObj = children[i];
                            let subModel = childrenObj.subModel;
                            if (subModel && subModel.length > 0) { // 如果存在直属子节点则取出来
                                for (let i = 0; i < subModel[i].length; i++) {
                                    let subModelObj = subModel[i];
                                    if (subModelObj.modelType < 2) { // 这是报表
                                        reportList.push(subModelObj);
                                    }
                                }
                            }
                            let childrenList = childrenObj.children;
                            if (childrenList && childrenList.length > 0) {
                                for (let i = 0; i < childrenList.length; i++) {
                                    let obj = childrenList[i];
                                    if (obj.modelType < 2) {
                                        reportList.push(obj);
                                    }
                                }
                            }
                        }
                    }
                }
                this.appSystemlList = reportList;
            }
        },
        async handleModelSelected (param) {
            let modelId = param.id;
            let modelObj = await getApplicationModelDetail(modelId);
            // 此处加判断,modelType 1 表单  2 报表 3 BI 4审批
            if (modelObj) {
                this.handleModelDetail(modelObj);
                this.selectedModel = modelObj;
                if (modelObj.modelType !== 3 && modelObj.modelType !== 4 && modelObj.modelType !== 5) {
                    this.setFormAuth(modelObj); // 设置表单权限
                    this.handleSwitchFormMode(1); // 切换数据列表
                }
                this.loadTimer = new Date().getTime();
            }
            this.modelId = modelId;
            this.nowMenuFormIndex = modelId;
        },
        setFormAuth (modelObj) {
            let currentUserStr = window.sessionStorage.getItem('currentUserInfo');
            let userInfo = JSON.parse(currentUserStr);
            let userFormAuth = userInfo.modelUserAuthMap[modelObj.formId];
            this.initFormAuth(true);
            if (!isEmpty(userFormAuth) && !isEmpty(userFormAuth.modelAuthList)) {
                this.initFormAuth(false);
                let authArr = userFormAuth.modelAuthList.split(',');
                for (let i = 0; i < authArr.length; i++) {
                    if (authArr[i] === '0') {
                        this.formBtnAuth.isShowView = true;
                    } else if (authArr[i] === '1') {
                        this.formBtnAuth.isShowAdd = true;
                    } else if (authArr[i] === '2') {
                        this.formBtnAuth.isShowEdit = true;
                    } else if (authArr[i] === '3') {
                        this.formBtnAuth.isShowDelete = true;
                    } else if (authArr[i] === '4') {
                        this.formBtnAuth.isShowImport = true;
                    } else if (authArr[i] === '5') {
                        this.formBtnAuth.isShowExport = true;
                    } else if (authArr[i] === '6') {
                        this.formBtnAuth.isShowSyn = true;
                    } else if (authArr[i] === '7') {
                        this.formBtnAuth.isShowConfig = true;
                    }
                }
            }
        },
        initFormAuth (flg) {
            this.formBtnAuth.isShowView = flg; // 查看
            this.formBtnAuth.isShowAdd = flg; // 新增
            this.formBtnAuth.isShowEdit = flg; // 修改
            this.formBtnAuth.isShowDelete = flg; // 删除
            this.formBtnAuth.isShowImport = flg; // 导入
            this.formBtnAuth.isShowExport = flg; // 导出
            this.formBtnAuth.isShowSyn = flg; // 同步流程数据
            this.formBtnAuth.isShowConfig = flg; // 进入应用配置
        },
        async handleApplicationSelected (app) {
            this.isShowModelList = false;
            this.selectedApp = app;
            let models = await getPublishedModelbyAppIdList(app.id);
            this.modelList = models;
            this.isShowModelList = true;
        },
        async handleModelDetail (model) {
            this.isShowModelDetail = false;
            this.isShowModelFormList = false;
            this.isShowdApproveModel = false;
            this.isShowBi = false;
            this.isShowWarehousing = false;
            this.selectedModel = model;
            // 模型类型
            if (model.modelType < 2) {
                // 0:普通表单 1.任务表单
                this.renderModelDetail(model);
                this.isShowModelFormList = true;
                this.isShowBi = false;
                this.isShowdApproveModel = false;
                this.isShowWarehousing = false;
            } else if (model.modelType === 2) {
                // 2.列表/报表
                this.renderModelDetail(model);
                this.isShowModelFormList = true;
                this.isShowBi = false;
                this.isShowdApproveModel = false;
                this.isShowWarehousing = false;
            } else if (model.modelType === 3) {
                this.isShowdApproveModel = false;
                this.isShowWarehousing = false;
                this.BiSearchCondition.formId = model.formId;
                this.getBiData(null, true);
            } else if (model.modelType === 4) {
                this.isShowBi = false;
                this.isShowWarehousing = false;
                this.getApproveData(model.formId);
            } else if (model.modelType === 5) {
                this.isShowBi = false;
                this.isShowdApproveModel = false;
                this.isShowModelFormList = false;
                this.isShowWarehousing = true;
                this.getWarehousing(model);
            } else {
                this.messageTip('找不到模型对应类型', 'warning');
                return false;
            }
        },
        async getApproveData (formId) {
            let res = await getApproveData(formId);
            this.approveModel.approveModelIds = res.approveModelIds;
            this.approveModel.approveFromIds = res.approveFromIds;
            this.loadTimer = new Date().getTime();
            this.isShowdApproveModel = true;
        },
        async getBiData (searchCondition, isInitSearch) {
            this.BiSearchCondition.searchCondition = searchCondition;
            // 2.列表/报表
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let obj = await getFormDashBoardData(this.BiSearchCondition);
            loading.close();
            this.chartType = obj.chartType;
            this.chartSettings = obj.chartSettings;
            this.chartData = obj.chartData;
            this.selectedModel.dataModelId = obj.dataModelId;
            this.selectedModel.dataFormId = obj.dataFormId;
            this.isShowBi = true;
            this.isShowModelForm = obj.showDataSource;
            if (this.isShowModelForm === 1) {
                setTimeout(() => {
                // 调用子组件的方法
                    this.$refs.dashBoardRef.renderFormList(this.selectedModel, isInitSearch, searchCondition);
                }, 0);
            }
        },
        async renderModelDetail (model) {
            this.modelId = model.id;
            this.formInfo = await getModelFormById(model.id);
            this.formInfo.modelName = model.modelName;
            this.formInfo.appName = model.fappName;
            this.formInfo.remarks = model.remarks;
            this.formInfo.modelType = model.modelType;
            this.formInfo.formId = model.formId;
        },
        async renderModelFormList (model) {
            this.isShowModelFormList = true;
            setTimeout(() => {
                // 调用子组件的方法
                // this.$refs.formListChild.renderFormList(model, true);
                if (this.searchFieldList.length > 0) {
                    model.leftTreeMode = true;
                } else {
                    this.searchConditionExt = null;
                }
                if (!isEmpty(this.searchConditionExt) && this.searchConditionExt.length > 0) {
                    this.$refs.formListChild.renderFormList(model, true, this.searchConditionExt);
                } else {
                    this.$refs.formListChild.renderFormList(model, true);
                }
            }, 0);
            this.isShowBi = false;
        },
        async handleModelComplete (model) {
            if (objectKeyIsEmpty(model.forms[0].values, model.forms[0].attributes)) {
                this.$confirm(`表单数据为空，数据将不会保存！`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then((res) => {
                    this.handleSwitchFormMode(1);
                }).catch(() => {});
            } else {
                // let res = await this.checkDataLegitimacy(model);
                // if (res) {
                //     let loading = this.$loading({
                //         lock: true,
                //         text: 'Loading',
                //         spinner: 'el-icon-loading',
                //         background: 'rgba(0, 0, 0, 0.7)'
                //     });
                //     model.modelId = this.modelId;
                //     await saveAppModelForm(this.modelId, model);
                //     setTimeout(() => {
                //         this.handleSwitchFormMode(1);
                //     }, 0);
                //     loading.close();
                // }
                // console.log(111);
                let values = model.forms[0].values;
                let formId = model.forms[0].formId;
                let modelId = model.modelId;
                let param = {values: values, formId: formId, modelId: modelId, modelType: this.selectedModel.modelType};
                let res = await checkDataLegitimacy(param);
                if (res.state === 'success') {
                    if (res.warnFlag) {
                        this.$confirm('与系统中已有的数据相似度达【' + res.similarity + '%】,是否继续保存？', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(async (ret) => {
                            this.saveAppModelForm(model);
                        }).catch(() => {});
                    } else {
                        this.saveAppModelForm(model);
                    }
                    return true;
                } else {
                    if (res.msg) {
                        this.$message.error(res.msg);
                    } else {
                        this.$message.error('数据不合法');
                    }
                    return false;
                }
            }
        },
        async saveAppModelForm (model) {
            let loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            model.modelId = this.modelId;
            await saveAppModelForm(this.modelId, model);
            setTimeout(() => {
                this.handleSwitchFormMode(1);
            }, 0);
            loading.close();
        },
        async checkDataLegitimacy (model) {
            let values = model.forms[0].values;
            let formId = model.forms[0].formId;
            let modelId = model.modelId;
            let param = {values: values, formId: formId, modelId: modelId, modelType: this.selectedModel.modelType};
            let res = await checkDataLegitimacy(param);
            if (res.state === 'success') {
                return true;
            } else {
                if (res.msg) {
                    this.$message.error(res.msg);
                } else {
                    this.$message.error('数据不合法');
                }
                return false;
            }
        },
        async handleSwitchFormMode (mode) {
            this.isShowModelDetail = false;
            if (mode === 1 && this.formBtnAuth.isShowView) {
                // 切换到数据列表
                this.renderModelFormList(this.selectedModel);
                this.isShowModelFormList = true;
                this.isShowBi = false;
                if (!this.isNewMenu) {
                    this.$refs.applicationMenuRef.changeSwitch(1);
                }
            } else if (mode === 2) {
                // 切换到表单录入
                this.renderModelDetail(this.selectedModel);
                this.isShowModelDetail = true;
                this.setIsShowForm(false);
                this.loadTimerModelDetail = new Date().getTime();
                this.formInfo.formId = this.selectedModel.formId;
                setTimeout(() => {
                    this.$refs.modelDetailChild.loadFormData(this.formInfo);
                }, 0);
            }
        },
        messageTip (msg, type) {
            this.$message({
                message: msg,
                type: type,
                duration: 3000
            });
        },
        hideDialog () {
            // this.$refs.modelDetailChild.clearTimeOut();
            // this.$refs.formListChild._initFormData();
            this.isShowModelDetail = false;
        },
        clearTimeOut () {
            this.$refs.modelDetailChild.clearTimeOut();
            this.$refs.formListChild._initFormData();
        },
        hideSidebox () {
            this.active = false;
        },
        setIsShowForm (status) {
            this.isShowForm = status;
        },
        handleFullScreen () {
            this.ifFullScreen = true;
            setTimeout(() => {
                this.$refs.businessConsole.init_();
            }, 0);
        },
        setShowleftList (defaultSearchField) {
            if (this.treeState === 1) {
                this.treeState = 0;
            } else {
                this.treeState = 1;
            }
            this.leftContent = 'main-content-left-show';
            if (defaultSearchField && defaultSearchField.length > 0) {
                this.rightContent = 'right-content-show  right-content-show-search';
            } else {
                this.rightContent = 'right-content-show';
            }
        },
        collapseLeftSide (isCollapse, defaultSearchField) {
            this.isCollapseForInit = isCollapse;
            if (isCollapse) {
                this.leftContent = 'main-content-left-show';
                if (defaultSearchField && defaultSearchField.length > 0) {
                    this.rightContent = 'right-content-show  right-content-show-search';
                } else {
                    this.rightContent = 'right-content-show';
                }
            } else {
                this.leftContent = 'main-content-left-close';
                this.rightContent = 'right-content-close';
            }
        },
        async refreshSearchConditon (columns) {
            this.conditionFields.length = 0;
            let idArr = [];
            columns.forEach(item => {
                idArr.push(item.id);
            });
            let cfs = await getFormFieldListByIds(idArr.join(','));
            this.conditionFields = [];
            if (cfs && cfs.length > 0) {
                for (var i = 0; i < cfs.length; i++) {
                    if (cfs[i].type === 'subform') {
                        continue;
                    } else {
                        this.conditionFields.push(cfs[i]);
                    }
                }
            }
        },
        searchForList () {
            if (this.isShowBi) {
                this.getBiData(this.conditionFields);
            } else if (this.isShowModelFormList) {
                for (let i = 0; i < this.conditionFields.length; i++) {
                    let cur = this.conditionFields[i];
                    if (cur.type === 'link') {
                        cur.searchFieldId = cur.id + '-view';
                    }
                }
                this.$refs.formListChild.searchForList(this.conditionFields);
            }
        },
        resetSearchConditon () {
            if (this.isShowModelFormList) {
                this.$refs.formListChild.searchForList([], true);
            } else if (this.isShowBi) {
                this.getBiData([], true);
            }
        },
        async getWarehousing (model) {
            let param = {modelId: model.id};
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let obj = await getWarehousing(param);
            if (obj.state === 'success') {
                let layout = JSON.parse(obj.data.mouldData);
                this.warehousingPreviewData = layout;
            }
            loading.close();
            this.showDataWarehousingPreview = true;
        },
        handleNavPage () { // 审批流发起或保存成功返回处理逻辑
            this.$emit('handleNavPage');
        },
        async getNode (data) {
            if (data.modelId === '') {
                return;
            }
            if (data.pId == '8496') { // 党建，请求后端进行单点登录
                let res = await getPartyBUildingAuthorize();
                if (res) {
                    let authData = res.authData;
                    authData = JSON.parse(authData);
                    let data = authData.data;
                    if (data.state === 'success') {
                        let jumpUrl = data.jumpUrl;
                        let accessToken = data.accessToken;
                        jumpUrl = jumpUrl + '?accessToken=' + accessToken;
                        window.open(jumpUrl);
                    } else {
                        this.$message.error('单点请求失败');
                    }
                }
            }
            let modelId = data.modelId;
            let modelObj = await getApplicationModelDetail(modelId);
            // 此处加判断,modelType 1 表单  2 报表 3 BI 4审批
            if (modelObj) {
                this.handleModelDetail(modelObj);
                this.selectedModel = modelObj;
                if (modelObj.modelType !== 3 && modelObj.modelType !== 4 && modelObj.modelType !== 5) {
                    this.setFormAuth(modelObj); // 设置表单权限
                    this.handleSwitchFormMode(1); // 切换数据列表
                }
                this.loadTimer = new Date().getTime();
            }
            this.modelId = modelId;
            this.nowMenuFormIndex = modelId;
            await this._getTreeData(data).then(val => {
                // 初始化默认展开到第二级
                this.expandLeftTree();
                // this.getNode(data);
            });
        },
        handleClose (done) {
            // console.log('关闭了');
        },
        handleTreeNode (data, node, tree) {
            this.searchConditionExt = [];
            if (!data.root) {
                let condition = {};
                if (this.defaultField.type === 'department' || this.defaultField.type === 'businessTree' || this.defaultField.type === 'dictionary') {
                    this.selectedModel.resetPage = !this.selectedModel.currentNodeId || (this.selectedModel.currentNodeId !== data.id);
                    condition = {
                        id: this.defaultField.id,
                        formId: this.formId,
                        modelId: this.modelId,
                        type: this.defaultField.type,
                        operateType: 2,
                        conditionValue: data.id,
                        conditionValueView: data.label
                    };
                    this.selectedModel.currentNodeId = data.id;
                } else {
                    this.selectedModel.resetPage = !this.selectedModel.currentNodeId || (this.selectedModel.currentNodeId !== data.key);
                    condition = {
                        id: this.defaultField.id,
                        formId: this.formId,
                        modelId: this.modelId,
                        type: this.defaultField.type,
                        operateType: 2,
                        conditionValue: data.key
                    };
                    this.selectedModel.currentNodeId = data.key;
                }
                this.searchConditionExt.push(condition);
            }

            this.selectedModel.leftTreeMode = true;
            this.selectedModel.root = data.root;
            this.renderModelFormList(this.selectedModel);
        },
        async _getTreeData (obj) {
            this.searchTreeData = [];
            this.searchFieldList = [];
            let result = await getFormLeftTree({formId: obj.formId});
            if (result && result.treeData && result.treeData.length > 0) {
                this.isCollapseForInit = true;
                this.searchTreeData.push(result.treeData[0]);
                this.defaultField = result.formFieldList[0];
                this.searchFieldList = result.formFieldList;
                this.searchCacheList = result.treeData;
                this.$refs.formListChild.collapseLeftSide(true);
                this.rightContent = 'right-content-show right-content-show-search';
            } else {
                this.isCollapseForInit = false;
                if (this.$refs.formListChild) {
                    this.$refs.formListChild.collapseLeftSide(false);
                }
                this.rightContent = 'right-content-show';
            }
            if (result && result.formConditionFields) { // 搜索条件
                let defaultSearchField = JSON.parse(result.formConditionFields);
                this.$refs.formListChild.eachSearchField(defaultSearchField);
            } else {
                let defaultSearchField = [];
                if (this.$refs.formListChild) {
                    this.$refs.formListChild.eachSearchField(defaultSearchField);
                }
            }
            // this.expandLeftTree();
        },
        async expandLeftTree () {
            // 初始化默认展开到第二级
            if (this.searchTreeData && this.searchTreeData.length > 0) {
                this.idSearchExpandedArr = [];
                // this.idExpandedArr.push(this.treeData[0].id);
                this.idSearchExpandedArr.push(this.searchTreeData[0].key);
            }
        },
        handleCommand (command) {
            // console.log(command);
            // console.log(this.searchCacheList);
            this.searchTreeData = [];
            this.searchFieldList.find(item => {
                if (item.id === command) {
                    this.defaultField = item;
                }
            });
            let obj = this.searchCacheList.find(item => item.key === command);
            if (obj) {
                this.searchTreeData.push(obj);
                this.expandLeftTree();
            }
        }
    }
};
</script>

<style lang="less">
.main-content {
    display: flex;
    width: 100%;
    .main-content-left-show {
        overflow-x: auto;
        width: 240px;
        .left-content {
            width: 238px;
            @media screen and (min-width: 1024px) and (max-width: 1366px) {
               width: 220px;
            }
            border: 1px solid #e6e6e6;
            height: 96%;
            // overflow: auto;
			.element-sideEditor{
                height: auto;
				margin-bottom: 240px;
				position: relative;
			}
        }
        .el-menu {
            border-right: none;
        }
    }
    // .main-content-left-show:hover{
    //     overflow-x: auto;
    // }
    .main-content-left-close {
        overflow: auto;
        .left-content {
            border: 1px solid #e6e6e6;
            display: none;
        }
    }
    .right-content-show {
        width: calc(~'100% - 240px');
        .form-data-box{
            display: flex;
            height: 100%;
            position: relative;
            width: 100%;
            .model-form-list-box{
                width: 100%;
                .dynamic-table{
                    width: 100%;
                }
            }
            .model-form-list-box-two{
                width: calc(~'100% - 240px');
                .dynamic-table{
                    width: 100%;
                }
            }
            .content-tree{
                width: auto;
                display: flex;
                height: 80vh;
                overflow-y:auto;
                // overflow: auto;
                .left-icon{
                    cursor: pointer;
                    width: 20px;
                    height: 24px;
                    text-align: center;
                    padding-top: 2px;
                    padding-right: 10px;
                    position: fixed;
                    margin-left: 185px;
                }
                .el-tree{
                    width: 220px;
                    @media screen and (min-width: 1024px) and (max-width: 1366px) {
                        width: 180px;
                    }
                }
            }
        }
        .approve-model-content{
            padding-right: 2vw;
        }
        .bi-form{
            height: 100%;
            .BI-content{
               position: relative;
               width: 100%;
               height: ~"calc(100% - 30px)";
               .BI-area{
                   position: relative;
                   width: 100%;
                   height: 100%;
                   text-align: center;
                   .BI-area-one{
                       position: relative;
                       height: 100%;
                       .ve-histogram{
                          height: ~"calc(100% + 30px)" !important;
                       }
                   }
                   .is-justify-end{
                       margin-top: -12px;
                   }
               }
            }
        }
        .warehousing-model-content{
            height: 100%;
            .model-data-warehousing{
                height: 100%;
                overflow: auto;
                position: relative;
                .main-content-top{
                    display: none;
                }
                .main-content-center{
                    height: ~"calc(100% - 8px)";
                    overflow: auto;
                    margin-top: 4px;
                    margin-bottom: 4px;
                    background: #FFFFFF;
                    margin-left: 4px;
                    margin-right: 4px;
                    border-radius: 4px;
                    width: ~"calc(100% - 8px)";
                    overflow-x: hidden;
                    .vue-grid-layout{
                        height: 100%;
                        .vue-grid-item{
                            border: 1px solid #FFFFFF;
                            box-shadow: 0 1px 3px rgba(0,0,0,.35);
                            border-radius: 4px;
                            background-color: #FFFFFF;
                            .tool-bar{
                                width: 100%;
                                height: 30px;
                                line-height: 26px;
                                border-bottom: 1px solid #e0e0e0;
                                display: flex;
                                .tit{
                                    flex: 1;
                                    .grid-item-title{
                                        text-indent: 2em;
                                        border: none;
                                        height: 24px;
                                        outline: none;
                                        width: 80%;
										background: #FFFFFF;
                                    }
                                }
                                .tool-bar-opera{
                                    float: right;
                                    display: flex;
                                    padding-right:6px;
                                    .search-tool{
                                        cursor: pointer;
                                        width: 30px;
                                        text-align: center;
                                        height: 28px;
                                        line-height: 28px;
                                    }
                                    .search-tool{
                                        text-align: center;
                                      .icon-other-xuanzhong2x{
                                          font-size: 14px;
                                      }
                                    }
                                    .search-tool:hover{
                                       .icon-other-xuanzhong2x{
                                           color: #81d0f1;
                                       }
                                       .up-tool-group{
                                           display: block;
                                           z-index: 9999;
                                           position: relative;
                                       }
                                    }
                                }
                            }
                            .main-content{
                                width:100%;
                                height: ~"calc(100% - 30px)";
                                overflow: auto;
                            }
                            .main-content-body{
                                width:100%;
                                height: ~"calc(100% - 30px)";
                                overflow: auto;
                                .main-data-workplant{
                                    padding-bottom: 10px;
                                }
                                .main-content-search{
                                    border: 1px solid #F0F0F0;
                                    position: absolute;
                                    background-color: #FFFFFF;
                                    right: 0px;
                                    top: 0px;
                                    // right: -370px;
                                    width: 360px;
                                    height: 100%;
                                    z-index: 11;
                                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
                                    border-radius: 4px;
                                    .main-content-search-box{
                                        height: ~"calc(100% - 40px)";
                                        overflow: auto;
                                       .el-collapse-item__content{
                                           overflow: auto;
                                       }
                                    }
                                    .item-field-search-content-btn{
                                        text-align: right;
                                        height: 40px;
                                        line-height: 40px;
                                        padding-right: 10px;
                                    }
                                }
                                .BI-area{
                                    height: 100%;
                                }
                            }

                        }
                    }
                }
            }
        }
        .el-table{
            // width: calc(~'100vw - 270px') !important;
            width: 100%;
        }
        // .model-content{
        //     height: calc(~'100% - 70px') !important;
        // }
    }
    .right-content-show-search {
        .el-table{
            // width: calc(~'100vw - 520px') !important;
            @media screen and (min-width: 1024px) and (max-width: 1366px) {
                width: calc(~'100vw - 468px') !important;
            }
        }
        .model-content{
            height: calc(~'100% - 70px') !important;
        }
    }
    .right-content-close {
        width: 100%;
    }
    ::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }
    /* 滚动槽 */
    ::-webkit-scrollbar-track {
        border-radius: 6px;
    }
    /* 滚动条滑块 */
    ::-webkit-scrollbar-thumb {
        border-radius: 6px;
        background-color: rgb(222, 220, 220);
    }
}
.popAddModelDetail {
    .el-dialog__body {
        padding: 0px 0px 0px 0px;
        color: #606266;
        font-size: 14px;
        word-break: break-all;
        // height: ~"calc(100% - 8vh)";
    }
}
.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
    background-color: #51a5e8;
    color: #FFFFFF;
}
.el-tree-node__children{
    overflow-x: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/business/BusinessApplication/BusinessAppMenu.vue